import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PrintViewParadan from "./PrintViewParadan";
import { change_Lang } from "../../../actions/Helper_action";
import { View_Paradan_Bill } from "../../../actions_agent/Invoice_action";
export class Print_ViewParadan extends Component {
  componentDidMount() {
    this.props.View_Paradan_Bill(
      this.props.match.params.id,
      this.props.match.params.index
    );
  }
  render() {
    const { view_paradan_obj, lang, change_Lang, index_Paradan, user } =
      this.props;
    return (
      <Fragment>
        <div className="container-fluid">
          <PrintViewParadan
            view_paradan_obj={view_paradan_obj}
            lang={lang}
            change_Lang={change_Lang}
            index_Paradan={index_Paradan}
            user={user}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    user: state.AuthReducer.user,
    view_paradan_obj: state.Invoice_Reducer.view_paradan_obj,
    paradan_lists: state.Invoice_Reducer.paradan_lists,
    index_Paradan: state.Invoice_Reducer.index_Paradan,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    View_Paradan_Bill: (id, index) => dispatch(View_Paradan_Bill(id, index)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Print_ViewParadan);
